import apiClient from './api';
import { FinancialOverview, Transaction, Account, ApiResponse } from '../types';

// Export types for convenience
export type { Transaction, Account, FinancialOverview } from '../types';

// Helper function to extract transactions from the service response
export const getTransactions = async (params?: {
  page?: number;
  limit?: number;
  category?: string;
  type?: 'income' | 'expense';
}): Promise<Transaction[]> => {
  const response = await financialService.getTransactions(params);

  return response.data?.transactions || [];
};

export const financialService = {
  // Get financial overview
  getOverview: async (): Promise<ApiResponse<FinancialOverview>> => {
    const response = await apiClient.get('/financial/overview');

    return response.data;
  },

  // Get transactions with filters
  getTransactions: async (params?: {
    page?: number;
    limit?: number;
    category?: string;
    type?: 'income' | 'expense';
  }): Promise<
    ApiResponse<{
      transactions: Transaction[];
      pagination: {
        page: number;
        limit: number;
        total: number;
        pages: number;
      };
    }>
  > => {
    const response = await apiClient.get('/financial/transactions', { params });

    return response.data;
  },

  // Get user accounts
  getAccounts: async (): Promise<ApiResponse<{ accounts: Account[] }>> => {
    const response = await apiClient.get('/financial/accounts');

    return response.data;
  },

  // Get financial analytics
  getAnalytics: async (
    period?: string,
  ): Promise<
    ApiResponse<{
      monthlyTrends: Array<{ month: string; income: number; expenses: number }>;
      categoryBreakdown: Array<{ category: string; amount: number; percentage: number }>;
      insights: string[];
    }>
  > => {
    const response = await apiClient.get('/financial/analytics', {
      params: { period },
    });

    return response.data;
  },
};
